var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"rotate":-90,"size":150,"width":15,"color":"primary","indeterminate":""}},[_vm._v(" Configurando aguarde... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }